module.exports = __webpack_public_path__ + "static/img/egg_b_21.7aed000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_21.png
// module id = TBSi
// module chunks = 1